const math = require('mathjs');
const numeral = require('numeral');
import {
  EQUALS,
  NOT_EQUAL,
} from '../../features/collections/collection/derived-query/query-constant';
const numberPatterns = [
  '0.0',
  '00.00',
  '0.00',
  '0.000',
  '00.000',
  '0a',
  '0o',
  '0b',
  '0.00b',
  '0.0 b',
  '0%',
  '0.00%',
];

const percentagePatterns = ['0%', '0.0%', '0.00%', 'A/B'];
const positions = ['FRONT', 'BACK', 'FRONT_WITH_SPACE', 'BACK_WITH_SPACE'];
const currencyPatterns = ['en-US', 'en-IN', 'pt-BR'];
const currencyList = [
  { name: 'None', code: 'NONE', symbol: 'NONE' },
  { name: 'Afghan Afghani', code: 'AFA', symbol: '؋' },
  { name: 'Albanian Lek', code: 'ALL', symbol: 'Lek' },
  { name: 'Algerian Dinar', code: 'DZD', symbol: 'دج' },
  { name: 'Angolan Kwanza', code: 'AOA', symbol: 'Kz' },
  { name: 'Argentine Peso', code: 'ARS', symbol: '$' },
  { name: 'Armenian Dram', code: 'AMD', symbol: '֏' },
  { name: 'Aruban Florin', code: 'AWG', symbol: 'ƒ' },
  { name: 'Australian Dollar', code: 'AUD', symbol: '$' },
  { name: 'Azerbaijani Manat', code: 'AZN', symbol: 'm' },
  { name: 'Bahamian Dollar', code: 'BSD', symbol: 'B$' },
  { name: 'Bahraini Dinar', code: 'BHD', symbol: '.د.ب' },
  { name: 'Bangladeshi Taka', code: 'BDT', symbol: '৳' },
  { name: 'Barbadian Dollar', code: 'BBD', symbol: 'Bds$' },
  { name: 'Belarusian Ruble', code: 'BYR', symbol: 'Br' },
  { name: 'Belgian Franc', code: 'BEF', symbol: 'fr' },
  { name: 'Belize Dollar', code: 'BZD', symbol: '$' },
  { name: 'Bermudan Dollar', code: 'BMD', symbol: '$' },
  { name: 'Bhutanese Ngultrum', code: 'BTN', symbol: 'Nu.' },
  { name: 'Bitcoin', code: 'BTC', symbol: '฿' },
  { name: 'Bolivian Boliviano', code: 'BOB', symbol: 'Bs.' },
  { name: 'Bosnia-Herzegovina Convertible Mark', code: 'BAM', symbol: 'KM' },
  { name: 'Botswanan Pula', code: 'BWP', symbol: 'P' },
  { name: 'Brazilian Real', code: 'BRL', symbol: 'R$' },
  { name: 'British Pound Sterling', code: 'GBP', symbol: '£' },
  { name: 'Brunei Dollar', code: 'BND', symbol: 'B$' },
  { name: 'Bulgarian Lev', code: 'BGN', symbol: 'Лв.' },
  { name: 'Burundian Franc', code: 'BIF', symbol: 'FBu' },
  { name: 'Cambodian Riel', code: 'KHR', symbol: 'KHR' },
  { name: 'Canadian Dollar', code: 'CAD', symbol: '$' },
  { name: 'Cape Verdean Escudo', code: 'CVE', symbol: '$' },
  { name: 'Cayman Islands Dollar', code: 'KYD', symbol: '$' },
  { name: 'CFA Franc BCEAO', code: 'XOF', symbol: 'CFA' },
  { name: 'CFA Franc BEAC', code: 'XAF', symbol: 'FCFA' },
  { name: 'CFP Franc', code: 'XPF', symbol: '₣' },
  { name: 'Chilean Peso', code: 'CLP', symbol: '$' },
  { name: 'Chinese Yuan', code: 'CNY', symbol: '¥' },
  { name: 'Colombian Peso', code: 'COP', symbol: '$' },
  { name: 'Comorian Franc', code: 'KMF', symbol: 'CF' },
  { name: 'Congolese Franc', code: 'CDF', symbol: 'FC' },
  { name: 'Costa Rican ColÃ³n', code: 'CRC', symbol: '₡' },
  { name: 'Croatian Kuna', code: 'HRK', symbol: 'kn' },
  { name: 'Cuban Convertible Peso', code: 'CUC', symbol: '$, CUC' },
  { name: 'Czech Republic Koruna', code: 'CZK', symbol: 'Kč' },
  { name: 'Danish Krone', code: 'DKK', symbol: 'Kr.' },
  { name: 'Djiboutian Franc', code: 'DJF', symbol: 'Fdj' },
  { name: 'Dominican Peso', code: 'DOP', symbol: '$' },
  { name: 'East Caribbean Dollar', code: 'XCD', symbol: '$' },
  { name: 'Egyptian Pound', code: 'EGP', symbol: 'ج.م' },
  { name: 'Eritrean Nakfa', code: 'ERN', symbol: 'Nfk' },
  { name: 'Estonian Kroon', code: 'EEK', symbol: 'kr' },
  { name: 'Ethiopian Birr', code: 'ETB', symbol: 'Nkf' },
  { name: 'Euro', code: 'EUR', symbol: '€' },
  { name: 'Falkland Islands Pound', code: 'FKP', symbol: '£' },
  { name: 'Fijian Dollar', code: 'FJD', symbol: 'FJ$' },
  { name: 'Gambian Dalasi', code: 'GMD', symbol: 'D' },
  { name: 'Georgian Lari', code: 'GEL', symbol: 'ლ' },
  { name: 'German Mark', code: 'DEM', symbol: 'DM' },
  { name: 'Ghanaian Cedi', code: 'GHS', symbol: 'GH₵' },
  { name: 'Gibraltar Pound', code: 'GIP', symbol: '£' },
  { name: 'Greek Drachma', code: 'GRD', symbol: '₯, Δρχ, Δρ' },
  { name: 'Guatemalan Quetzal', code: 'GTQ', symbol: 'Q' },
  { name: 'Guinean Franc', code: 'GNF', symbol: 'FG' },
  { name: 'Guyanaese Dollar', code: 'GYD', symbol: '$' },
  { name: 'Haitian Gourde', code: 'HTG', symbol: 'G' },
  { name: 'Honduran Lempira', code: 'HNL', symbol: 'L' },
  { name: 'Hong Kong Dollar', code: 'HKD', symbol: '$' },
  { name: 'Hungarian Forint', code: 'HUF', symbol: 'Ft' },
  { name: 'Icelandic KrÃ³na', code: 'ISK', symbol: 'kr' },
  { name: 'Indian Rupee', code: 'INR', symbol: '₹' },
  { name: 'Indonesian Rupiah', code: 'IDR', symbol: 'Rp' },
  { name: 'Iranian Rial', code: 'IRR', symbol: '﷼' },
  { name: 'Iraqi Dinar', code: 'IQD', symbol: 'د.ع' },
  { name: 'Israeli New Sheqel', code: 'ILS', symbol: '₪' },
  { name: 'Italian Lira', code: 'ITL', symbol: 'L,£' },
  { name: 'Jamaican Dollar', code: 'JMD', symbol: 'J$' },
  { name: 'Japanese Yen', code: 'JPY', symbol: '¥' },
  { name: 'Jordanian Dinar', code: 'JOD', symbol: 'ا.د' },
  { name: 'Kazakhstani Tenge', code: 'KZT', symbol: 'лв' },
  { name: 'Kenyan Shilling', code: 'KES', symbol: 'KSh' },
  { name: 'Kuwaiti Dinar', code: 'KWD', symbol: 'ك.د' },
  { name: 'Kyrgystani Som', code: 'KGS', symbol: 'лв' },
  { name: 'Laotian Kip', code: 'LAK', symbol: '₭' },
  { name: 'Latvian Lats', code: 'LVL', symbol: 'Ls' },
  { name: 'Lebanese Pound', code: 'LBP', symbol: '£' },
  { name: 'Lesotho Loti', code: 'LSL', symbol: 'L' },
  { name: 'Liberian Dollar', code: 'LRD', symbol: '$' },
  { name: 'Libyan Dinar', code: 'LYD', symbol: 'د.ل' },
  { name: 'Lithuanian Litas', code: 'LTL', symbol: 'Lt' },
  { name: 'Macanese Pataca', code: 'MOP', symbol: '$' },
  { name: 'Macedonian Denar', code: 'MKD', symbol: 'ден' },
  { name: 'Malagasy Ariary', code: 'MGA', symbol: 'Ar' },
  { name: 'Malawian Kwacha', code: 'MWK', symbol: 'MK' },
  { name: 'Malaysian Ringgit', code: 'MYR', symbol: 'RM' },
  { name: 'Maldivian Rufiyaa', code: 'MVR', symbol: 'Rf' },
  { name: 'Mauritanian Ouguiya', code: 'MRO', symbol: 'MRU' },
  { name: 'Mauritian Rupee', code: 'MUR', symbol: '₨' },
  { name: 'Mexican Peso', code: 'MXN', symbol: '$' },
  { name: 'Moldovan Leu', code: 'MDL', symbol: 'L' },
  { name: 'Mongolian Tugrik', code: 'MNT', symbol: '₮' },
  { name: 'Moroccan Dirham', code: 'MAD', symbol: 'MAD' },
  { name: 'Mozambican Metical', code: 'MZM', symbol: 'MT' },
  { name: 'Myanmar Kyat', code: 'MMK', symbol: 'K' },
  { name: 'Namibian Dollar', code: 'NAD', symbol: '$' },
  { name: 'Nepalese Rupee', code: 'NPR', symbol: '₨' },
  { name: 'Netherlands Antillean Guilder', code: 'ANG', symbol: 'ƒ' },
  { name: 'New Taiwan Dollar', code: 'TWD', symbol: '$' },
  { name: 'New Zealand Dollar', code: 'NZD', symbol: '$' },
  { name: 'Nicaraguan CÃ³rdoba', code: 'NIO', symbol: 'C$' },
  { name: 'Nigerian Naira', code: 'NGN', symbol: '₦' },
  { name: 'North Korean Won', code: 'KPW', symbol: '₩' },
  { name: 'Norwegian Krone', code: 'NOK', symbol: 'kr' },
  { name: 'Omani Rial', code: 'OMR', symbol: '.ع.ر' },
  { name: 'Pakistani Rupee', code: 'PKR', symbol: '₨' },
  { name: 'Panamanian Balboa', code: 'PAB', symbol: 'B/.' },
  { name: 'Papua New Guinean Kina', code: 'PGK', symbol: 'K' },
  { name: 'Paraguayan Guarani', code: 'PYG', symbol: '₲' },
  { name: 'Peruvian Nuevo Sol', code: 'PEN', symbol: 'S/.' },
  { name: 'Philippine Peso', code: 'PHP', symbol: '₱' },
  { name: 'Polish Zloty', code: 'PLN', symbol: 'zł' },
  { name: 'Qatari Rial', code: 'QAR', symbol: 'ق.ر' },
  { name: 'Romanian Leu', code: 'RON', symbol: 'lei' },
  { name: 'Russian Ruble', code: 'RUB', symbol: '₽' },
  { name: 'Rwandan Franc', code: 'RWF', symbol: 'FRw' },
  { name: 'Salvadoran ColÃ³n', code: 'SVC', symbol: '₡' },
  { name: 'Samoan Tala', code: 'WST', symbol: 'SAT' },
  { name: 'Saudi Riyal', code: 'SAR', symbol: '﷼' },
  { name: 'Serbian Dinar', code: 'RSD', symbol: 'din' },
  { name: 'Seychellois Rupee', code: 'SCR', symbol: 'SRe' },
  { name: 'Sierra Leonean Leone', code: 'SLL', symbol: 'Le' },
  { name: 'Singapore Dollar', code: 'SGD', symbol: '$' },
  { name: 'Slovak Koruna', code: 'SKK', symbol: 'Sk' },
  { name: 'Solomon Islands Dollar', code: 'SBD', symbol: 'Si$' },
  { name: 'Somali Shilling', code: 'SOS', symbol: 'Sh.so.' },
  { name: 'South African Rand', code: 'ZAR', symbol: 'R' },
  { name: 'South Korean Won', code: 'KRW', symbol: '₩' },
  { name: 'Special Drawing Rights', code: 'XDR', symbol: 'SDR' },
  { name: 'Sri Lankan Rupee', code: 'LKR', symbol: 'Rs' },
  { name: 'St. Helena Pound', code: 'SHP', symbol: '£' },
  { name: 'Sudanese Pound', code: 'SDG', symbol: '.س.ج' },
  { name: 'Surinamese Dollar', code: 'SRD', symbol: '$' },
  { name: 'Swazi Lilangeni', code: 'SZL', symbol: 'E' },
  { name: 'Swedish Krona', code: 'SEK', symbol: 'kr' },
  { name: 'Swiss Franc', code: 'CHF', symbol: 'CHf' },
  { name: 'Syrian Pound', code: 'SYP', symbol: 'LS' },
  { name: 'São Tomé and Príncipe Dobra', code: 'STD', symbol: 'Db' },
  { name: 'Tajikistani Somoni', code: 'TJS', symbol: 'SM' },
  { name: 'Tanzanian Shilling', code: 'TZS', symbol: 'TSh' },
  { name: 'Thai Baht', code: 'THB', symbol: '฿' },
  { name: "Tongan Pa'anga", code: 'TOP', symbol: '$' },
  { name: 'Trinidad & Tobago Dollar', code: 'TTD', symbol: '$' },
  { name: 'Tunisian Dinar', code: 'TND', symbol: 'ت.د' },
  { name: 'Turkish Lira', code: 'TRY', symbol: '₺' },
  { name: 'Turkmenistani Manat', code: 'TMT', symbol: 'T' },
  { name: 'Ugandan Shilling', code: 'UGX', symbol: 'USh' },
  { name: 'Ukrainian Hryvnia', code: 'UAH', symbol: '₴' },
  { name: 'United Arab Emirates Dirham', code: 'AED', symbol: 'إ.د' },
  { name: 'Uruguayan Peso', code: 'UYU', symbol: '$' },
  { name: 'US Dollar', code: 'USD', symbol: '$' },
  { name: 'Uzbekistan Som', code: 'UZS', symbol: 'лв' },
  { name: 'Vanuatu Vatu', code: 'VUV', symbol: 'VT' },
  { name: 'Venezuelan BolÃvar', code: 'VEF', symbol: 'Bs' },
  { name: 'Vietnamese Dong', code: 'VND', symbol: '₫' },
  { name: 'Yemeni Rial', code: 'YER', symbol: '﷼' },
  { name: 'Zambian Kwacha', code: 'ZMK', symbol: 'ZK' },
];

export const labelForCurrency = (currency) => {
  const { name, code, symbol } = currencyList.find((item) => item.code === currency.code);
  if (code === 'NONE') return 'None';
  return `${code} ( ${symbol} ) - ${name}`;
};

export const labelForPercentagePatterns = (format) => {
  switch (format) {
    case '0%':
      return `0% (i.e.: 24%)`;
    case '0.0%':
      return `0.0% (i.e.: 23.6%)`;
    case '0.00%':
      return `0.00% (i.e.: 23.57%)`;
    case 'A/B':
      return `A/B (i.e.: 3/10)`;
  }
};

export const labelForCurrencyPosition = (position, currencyDisplay) => {
  switch (position) {
    case 'FRONT':
      return `At the Beginning (i.e.: ${currencyDisplay}44.00 )`;
    case 'FRONT_WITH_SPACE':
      return `At the Beginning with space (i.e.: ${currencyDisplay} 44.00)`;
    case 'BACK':
      return `At the End (i.e.: 44.00${currencyDisplay})`;
    case 'BACK_WITH_SPACE':
      return `At the End with space (i.e.: 44.00 ${currencyDisplay})`;
  }
};

export const labelForCurrencyDisplay = (type, currency) => {
  switch (type) {
    case 'code':
      return `Code (i.e.: ${currency ? currency['code'] : 'USD'} )`;
    case 'symbol':
      return `Symbol (i.e.: ${currency ? currency['symbol'] : '$'} )`;
  }
};

export const labelForCurrencyPattern = (pattern, currencyDisplay) => {
  if (currencyDisplay === 'NONE') currencyDisplay = '';
  switch (pattern) {
    case 'en-IN':
      return `Lakhs and Crores (i.e.: ${currencyDisplay}12,34,567.89 )`;
    case 'en-US':
      return `Million and Billion (i.e.: ${currencyDisplay}1,234,567.89 )`;
    case 'pt-BR':
      return `Million and Billion in Euro Format (i.e.: ${currencyDisplay}1.234.567,89 )`;
  }
};

export const labelForCurrencymaxFraction = (fraction, currency) => {
  let currencyDisplay = currency ? currency['symbol'] : '$';
  if (currencyDisplay === 'NONE') currencyDisplay = '';
  const multiplier = Math.pow(10, fraction || 0);
  const digit = Math.round(44.568 * multiplier) / multiplier;
  return `${fraction} (i.e.: ${currencyDisplay}${digit})`;
};

export const lableForNumberPatters = (pattern) => {
  switch (pattern) {
    case '0.0':
      return `0.0`;
    case '00.00':
      return `00.00`;
    case '0.00':
      return `0.00 `;
    case '0.000':
      return `0.000`;
    case '00.000':
      return `00.000`;
    case '0a':
      return `0a (i.e.: 1460 will be converted to 1 k)`;
    case '0o':
      return `0o (i.e.: 1 will be converted to 1st, 100 will be converted to 100th, etc..)`;
    case '0b':
      return `0b (i.e.: 100 will be converted to 100B, 1024 will be converted to 1KB, etc..)`;
    case '0.00b':
      return `0.00b (i.e.: 7884486213 will be converted to 7.88GB )`;
    case '0.0 b':
      return `0.0 b (i.e.: 3072 will be converted to 3.1 KB )`;
    case '0%':
      return `0%`;
    case '0.00%':
      return `0.00%`;
    default:
      return pattern;
  }
};

export const math_datas = [
  {
    name: 'ADDITION',
    args: [
      {
        minArgCount: 2,
        maxArgCount: 0,
        name: 'numbers',
        label: 'Args',
        value: '',
        hint: 'Choose Fields from collection(only number type is allowed). ex: field1, field2',
      },
      {
        minArgCount: 1,
        maxArgCount: 1,
        name: 'formatType',
        label: 'Format Type',
        options: numberPatterns,
        value: '',
        hint: 'Choose format to represent the result',
      },
    ],
    allowedTypes: ['number'],
  },
  {
    name: 'AVERAGE',
    args: [
      {
        limit: false,
        minArgCount: 2,
        maxArgCount: 0,
        name: 'numbers',
        label: 'Args',
        value: '',
        hint: 'Choose Fields from collection(only number type is allowed). ex: field1, field2',
      },
      {
        minArgCount: 1,
        maxArgCount: 1,
        name: 'formatType',
        label: 'Format Type',
        options: numberPatterns,
        value: '',
        hint: 'Choose format to represent the result',
      },
    ],
    allowedTypes: ['number'],
  },
  {
    name: 'MULTIPLY',
    args: [
      {
        minArgCount: 2,
        maxArgCount: 0,
        name: 'numbers',
        label: 'Args',
        value: '',
        hint: 'Choose Fields from collection(only number type is allowed). ex: field1, field2',
      },
      {
        minArgCount: 1,
        maxArgCount: 1,
        name: 'formatType',
        label: 'Format Type',
        options: numberPatterns,
        value: '',
        hint: 'Choose format to represent the result',
      },
    ],
    allowedTypes: ['number'],
  },
  {
    name: 'DIVIDE',
    args: [
      {
        minArgCount: 1,
        maxArgCount: 1,
        name: 'number1',
        label: 'Arg 2',
        value: '',
        hint: 'Choose dividend field from collection(only number type is allowed). ex: numField1',
      },
      {
        minArgCount: 1,
        maxArgCount: 1,
        name: 'number2',
        label: 'Arg 2',
        value: '',
        hint: 'Choose divisor field from collection(only number type is allowed). ex: numField2',
      },
      {
        minArgCount: 1,
        maxArgCount: 1,
        name: 'formatType',
        label: 'Format Type',
        options: numberPatterns,
        value: '',
        hint: 'Choose format to represent the result',
      },
    ],
    allowedTypes: ['number'],
  },
  {
    name: 'SUBSTRACTION',
    args: [
      {
        minArgCount: 2,
        maxArgCount: 0,
        name: 'numbers1',
        label: 'Args 1',
        value: '',
        hint: 'Choose Fields from collection(only number type is allowed). ex: field1, field2',
      },
      {
        minArgCount: 2,
        maxArgCount: 0,
        name: 'numbers2',
        label: 'Args 2',
        value: '',
        hint: 'Choose Fields from collection(only number type is allowed). ex: field1, field2',
      },
      {
        minArgCount: 1,
        maxArgCount: 1,
        name: 'formatType',
        label: 'Format Type',
        options: numberPatterns,
        value: '',
        hint: 'Choose format to represent the result',
      },
    ],
    allowedTypes: ['number'],
  },
  {
    name: 'COUNT',
    args: [
      {
        minArgCount: 1,
        maxArgCount: 1,
        name: 'subject',
        label: 'Subject',
        value: '',
        hint: 'Choose field from collection (only Static Option, Dynamic Option and Reference type is allowed)',
      },
      {
        minArgCount: 1,
        maxArgCount: 1,
        name: 'condition',
        label: 'Condition',
        options: [EQUALS, NOT_EQUAL],
        value: '',
        hint: 'Select the Condition to match',
      },
      {
        minArgCount: 1,
        maxArgCount: 1,
        name: 'refField',
        label: 'Subject 2',
        value: '',
        hint: 'Choose field from collection (only Static Option and Dynamic Option is allowed)',
      },
      {
        minArgCount: 1,
        maxArgCount: 1,
        name: 'match',
        label: 'Match',
        value: '',
      },
    ],
    allowedTypes: ['static_option', 'reference', 'dynamic_option'],
  },
  {
    name: 'PERCENTAGE',
    args: [
      {
        minArgCount: 1,
        maxArgCount: 1,
        name: 'subject',
        label: 'Subject',
        value: '',
        hint: 'Choose field from collection (only Static Option, Dynamic Option and Reference type is allowed)',
      },
      {
        minArgCount: 1,
        maxArgCount: 1,
        name: 'condition',
        label: 'Condition',
        options: [EQUALS, NOT_EQUAL],
        value: '',
        hint: 'Select the Condition to match',
      },
      {
        minArgCount: 1,
        maxArgCount: 1,
        name: 'refField',
        label: 'Subject 2',
        value: '',
        hint: 'Choose field from collection (only Static Option and Dynamic Option is allowed)',
      },
      {
        minArgCount: 1,
        maxArgCount: 1,
        name: 'match',
        label: 'Match',
        value: '',
      },
      {
        minArgCount: 1,
        maxArgCount: 1,
        name: 'formatType',
        label: 'Format Type',
        options: percentagePatterns,
        value: '',
        hint: 'Choose format to represent the result',
      },
    ],
    allowedTypes: ['reference'],
  },
  {
    name: 'FIND_RECORD',
    args: [
      {
        minArgCount: 1,
        maxArgCount: 1,
        name: 'index',
        label: 'Index',
        options: ['FIRST_RECORD', 'LAST_RECORD'],
        value: '',
      },
      ,
      {
        minArgCount: 1,
        maxArgCount: 1,
        name: 'subject',
        label: 'Subject',
        value: '',
        hint: 'Choose field from collection (only Reference type is allowed)',
      },
      {
        minArgCount: 1,
        maxArgCount: 1,
        name: 'refField',
        label: 'Subject 2',
        value: '',
        hint: 'Choose field from collection (only Static Option and Dynamic Option is allowed)',
      },
    ],
    allowedTypes: ['reference'],
  },
  {
    name: 'CUSTOM_CALCULATION',
    args: [
      {
        minArgCount: 1,
        maxArgCount: 1,
        name: 'expression',
        label: 'Custom Calculation',
        value: '',
        external: true,
      },
      {
        minArgCount: 1,
        maxArgCount: 1,
        name: 'formatType',
        label: 'Format Type',
        options: numberPatterns,
        value: '',
        hint: 'Choose format to represent the result',
      },
    ],
    allowedTypes: ['number'],
  },
  {
    name: 'CUSTOM_JAVASCRIPT_LOGIC',
    args: [
      {
        minArgCount: 1,
        maxArgCount: 1,
        name: 'expression',
        label: 'Custom Logic',
        value: '',
        external: true,
      },
    ],
  },
  {
    name: 'CURRENCY_FORMAT',
    args: [
      {
        minArgCount: 1,
        maxArgCount: 1,
        name: 'subject',
        label: 'Subject',
        value: '',
        hint: 'Choose field from collection (number type is allowed)',
      },
      {
        minArgCount: 1,
        maxArgCount: 1,
        name: 'currency',
        label: 'Currency',
        options: currencyList,
        value: '',
        hint: 'Select the Currency.',
      },
      {
        minArgCount: 1,
        maxArgCount: 1,
        name: 'displayType',
        label: 'Display Type',
        options: ['code', 'symbol'],
        value: '',
        hint: 'Select the Currency Symbol',
      },
      {
        minArgCount: 1,
        maxArgCount: 1,
        name: 'position',
        label: 'Position',
        options: positions,
        value: '',
        hint: 'Add the currency symbol at beginning or end of number.',
      },
      {
        minArgCount: 1,
        maxArgCount: 1,
        name: 'formatType',
        label: 'Format Type',
        options: currencyPatterns,
        value: '',
        hint: 'Choose format to represent the result',
      },
      {
        minArgCount: 1,
        maxArgCount: 1,
        name: 'maxFraction',
        label: 'Fraction Point',
        options: [0, 1, 2, 3],
        value: '',
        hint: 'Choose number of fraction to show the result',
      },
    ],
    allowedTypes: ['number'],
  },
];

// Math Operations
export const ADDITION = (formatType, ...numbers) => {
  return numeral(math.add(...numbers)).format(formatType ? formatType : '00.00');
};

export const AVERAGE = (formatType, ...numbers) => {
  return numeral(math.mean(...numbers)).format(formatType ? formatType : '00.00');
};

export const MULTIPLY = (formatType, ...numbers) => {
  return numeral(math.multiply(...numbers)).format(formatType ? formatType : '00.00');
};

export const DIVIDE = (formatType, { number1, number2 }) => {
  return numeral(math.divide(number1 / number2)).format(formatType ? formatType : '00.00');
};

export const SUBSTRACTION = (formatType, { numbers1, numbers2 }) => {
  return numeral(math.subtract(math.add(...numbers1), math.add(...numbers2))).format(
    formatType ? formatType : '00.00',
  );
};

export const COUNT = (subject) => {
  return subject.length;
};

export const PERCENTAGE = (subject, condition, refField, match, refFieldType, formatType) => {
  let total = subject.length;
  if (!total) return '0';
  let value = subject.filter((sub) => {
    if (['dynamic_option', 'static_option'].includes(refFieldType)) {
      if (condition === EQUALS) {
        return sub[refField].includes(match);
      } else if (condition === NOT_EQUAL) {
        return !sub[refField].includes(match);
      }
    } else return false;
  });
  value = value.length;
  const percentage = formatType.includes('%')
    ? numeral(math.divide(value, total)).format(formatType)
    : `${value}/${total}`;
  return percentage;
};

export const CUSTOM_CALCULATION = (subject) => {
  return subject.length;
};

export const CUSTOM_JAVASCRIPT_LOGIC = 'CUSTOM_JAVASCRIPT_LOGIC';

export const CURRENCY_FORMAT = (formatType, subject, currency, position, maxFraction) => {
  try {
    if (!subject) subject = 0;
    if (!maxFraction && maxFraction !== 0) maxFraction = 2;
    const multiplier = Math.pow(10, maxFraction || 0);
    const digit = Math.round(subject * multiplier) / multiplier;
    subject = new Intl.NumberFormat(formatType, { minimumFractionDigits: maxFraction }).format(
      digit,
    );
    switch (position) {
      case 'FRONT':
        return `${currency}${subject}`;
      case 'FRONT_WITH_SPACE':
        return `${currency} ${subject}`;
      case 'BACK':
        return `${subject}${currency}`;
      case 'BACK_WITH_SPACE':
        return `${subject} ${currency}`;
      default:
        return '';
    }
  } catch (error) {
    return '';
  }
};

export const FIND_RECORD = (subject, refField, index) => {
  if (index === 'FIRST_RECORD') return subject[0][refField];
  if (index === 'LAST_RECORD') return subject[subject.length - 1][refField];
};
